<template>
  <div class="hero-text-placeholder">
    <content-loader
      class="d-none d-lg-block"
      primary-color="#ffffff"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      width="278"
      height="410"
      viewBox="0 0 278 410"
    >
      <rect x="0" y="0" rx="0" ry="0" width="270" height="42" />
      <rect x="0" y="50" rx="0" ry="0" width="250" height="42" />
      <rect x="0" y="100" rx="0" ry="0" width="270" height="42" />
      <rect x="0" y="150" rx="0" ry="0" width="139" height="42" />
      <rect x="0" y="208" rx="0" ry="0" width="270" height="15" />
      <rect x="0" y="227" rx="0" ry="0" width="270" height="15" />
      <rect x="0" y="246" rx="0" ry="0" width="270" height="15" />
      <rect x="0" y="265" rx="0" ry="0" width="270" height="15" />
      <rect x="0" y="284" rx="0" ry="0" width="106" height="15" />
      <rect x="46" y="330" rx="30" ry="30" width="175" height="58" />
    </content-loader>
    <content-loader
      class="mt-5 d-lg-none"
      primary-color="#ffffff"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      :width="width"
      :height="totalHeight"
    >
      <rect
        v-for="hr in headingRows"
        :key="hr + 100"
        :x="gap"
        :y="getHeadingRowPosition(hr)"
        :width="getRowWidth(hr === headingRows, 0.25)"
        :height="headingRowHeight"
      />

      <rect
        v-for="tr in textRows"
        :key="tr + 200"
        :x="gap"
        :y="getTextRowPosition(tr)"
        :width="getRowWidth(tr === textRows, 0.75)"
        :height="textRowHeight"
      />

      <rect :x="width / 2 - buttonWidth / 2" :y="headingHeight + textHeight" rx="30" ry="30" :width="buttonWidth" :height="buttonHeight" />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "hero-text-placeholder",
  components: { ContentLoader },
  data() {
    return {
      width: window.innerWidth,
      gap: 16,
      headingRows: 2,
      headingRowHeight: 38,
      headingGap: 6,
      headingBottomGap: 24,
      textRows: 3,
      textRowHeight: 15,
      textGap: 4,
      textBottomGap: 24,
      buttonHeight: 58,
    };
  },
  computed: {
    buttonWidth() {
      return this.width > 300 + this.gap * 2 ? 300 : this.width - this.gap * 2;
    },
    headingHeight() {
      return (this.headingRowHeight + this.headingGap) * this.headingRows + this.headingBottomGap;
    },
    textHeight() {
      return (this.textRowHeight + this.textGap) * this.textRows + this.textBottomGap;
    },
    totalHeight() {
      return this.headingHeight + this.textHeight + this.buttonHeight;
    },
  },
  methods: {
    getHeadingRowPosition(index) {
      return (index - 1) * (this.headingGap + this.headingRowHeight);
    },
    getTextRowPosition(index) {
      return this.headingHeight + (index - 1) * (this.textGap + this.textRowHeight);
    },
    getRowWidth(isLast, length = 1) {
      const width = this.width - this.gap * 2;
      return isLast ? width * length : width;
    },
    onResize() {
      this.width = window.innerWidth;
    },
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
};
</script>
